import {getDailyPlan} from "../../../../utils/dayPlan";
import {calculateProfTechByJobs} from "../../../../firestore/plan";
import firebase from "firebase";
import dayjs from "dayjs";
import {getPermission} from "../../../../firestore/permission";
import th from "vue2-datepicker/locale/es/th";

export const calcJobsPlan = {
  data() {
    return {
      saveJobs: {
        PROF: {},
        TECH: {},
      },
      permission: {}
    }
  },
  async beforeMount() {
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || authFirestore.currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id));
  },
  watch: {
    'form.datetime'(prev, next) {

      if(dayjs(prev).format('YYYY-DD-MM') === dayjs(next).format('YYYY-DD-MM')) {
        return
      }
      this.calcJobsPlan()
    },
    'form.turn'(prev, next) {
      if(prev.value === next.value) {
        return
      }
      this.calcJobsPlan()
    },
    'form.object': {
      handler(prev, next) {
        if(JSON.stringify(prev) === JSON.stringify(next)) {
          return
        }

        this.calcJobsPlan()
      },
      deep: true
    }
  },
  methods: {
    calcPlanResult(jobs, type) {
      this.form[type].itr = 0
      this.form[type].itr_plan = 0
      this.form[type].workers = 0
      this.form[type].workers_plan = 0

      jobs.forEach((jb) => {
        jb.forEach((j) => {
          if (j.job.kind && j.job.kind.value === 'itr') {
            this.form[type].itr = this.form[type].itr + Number(j.value)
            this.form[type].itr_plan = this.form[type].itr_plan + Number(j.plan)
          } else {
            this.form[type].workers = this.form[type].workers + Number(j.value)
            this.form[type].workers_plan = this.form[type].workers_plan + Number(j.plan)
          }
        });
      })
    },
    async calcJobsPlan() {
      if(!this.initData) {
        return
      }
      if(!this.$store.state.project.plan) {
        return
      }

      if(this.$route.params.type === 'JOB' || this.$route.params.type === 'MAIN') {
        const jobs = [...this.form.jobs]

        await Promise.all(this.form.jobs.map(async (job, index) => {
          const _job =  await myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('plan')
            .doc(this.$store.state.project.plan.id)
            .collection('jobs')
            .doc(job.job.id)
            .get()
          const volumes = (_job.data() &&  _job.data().volumes) || job.job.volumes

          jobs[index].daily_plan = getDailyPlan(this.form.datetime, volumes, this.form.turn.value)
        }))

        this.form.jobs = [...jobs]
      }


      if(this.$route.params.type === 'PROF' || this.$route.params.type === 'TECH') {
        this.form.jobs.forEach((jobs, index) => {
          jobs.forEach(async (job, i) => {
            this.form.jobs[index][i].plan = await calculateProfTechByJobs({
              planID: this.$store.state.project.plan.id,
              projectID: this.$store.state.project.id,
              objectID: (this.form.object && this.form.object.id) || null,
              date: this.form.datetime,
              permission: this.permission,
              profTechId: (job.job && job.job.id) || null,
              type: this.type || this.$route.params.type,
              turn: this.form.turn.value
            })
          })
        })
      }

      this.reCalcProfTech('PROF');
      this.reCalcProfTech('TECH');
    },

    async reCalcProfTech(type) {
      const getReportByID = async (id) => {
        if(!id) return null

        const result = await myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .doc(id).get()

        return result.data()
      }

      const report = await getReportByID(this.form[`report${type}`]);

      if(report) {
        report.jobs = Object.values(report.jobs)
        this.saveJobs.PROF = JSON.parse(JSON.stringify(report.jobs));
        await Promise.all(report.jobs.map(async (jobs, index) => {
          await Promise.all(jobs.map(async (job, i) => {
            report.jobs[index][i].plan = await calculateProfTechByJobs({
              planID: this.$store.state.project.plan.id,
              projectID: this.$store.state.project.id,
              permission: this.permission,
              objectID: (this.form.object && this.form.object.id) || null,
              date: this.form.datetime,
              profTechId: (job.job && job.job.id) || null,
              type: type,
              turn: this.form.turn.value
            })
          }))
        }))


        this.calcPlanResult(report.jobs, type)

        if(JSON.stringify(this.saveJobs[type]) === JSON.stringify(report.jobs)) {
          this.saveJobs[type] = null
        } else {
          this.saveJobs[type] = report.jobs
        }
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/Dashboard/Reports/mixins/calcJobsPlan.js